import { InvoicePreview } from '@components'
import { MODAL_SIZE } from '@constants'
import { ArrowRightWhiteSmallIcon } from '@icons'
import domPurify from 'dompurify'
import parse from 'html-react-parser'
import { paths, transformMerchantActivity, useActivitiesQry, useInvoicePreviewQry } from 'mmfintech-backend-api'
import type { MerchantActivityOut } from 'mmfintech-backend-api/types'
import { GlobalContext } from 'mmfintech-commons'
import { useContext } from 'react'

import './ActivityInfoLine.scss'

interface Props {
  activity: MerchantActivityOut
}

function ActivityInfoLine({ activity }: Props) {
  const { modalHide, modalShow } = useContext(GlobalContext)

  const { handleActivityClick } = useActivitiesQry({
    securityPath: paths.security(),
    handleInvoicePreview: invoiceId => previewInvoice(invoiceId)
  })

  const { fetchPreviewText /*, invoicePreviewError, invoicePreviewFetching*/ } = useInvoicePreviewQry()

  function previewInvoice(invoiceId: string | number) {
    void fetchPreviewText(Number(invoiceId), content => {
      modalShow({
        options: { size: MODAL_SIZE.EXTRA_LARGE },
        content: <InvoicePreview content={content} onClose={modalHide} />
      })
    })
  }

  const data = transformMerchantActivity(activity)
  function fixTime(i: number) {
    return i < 10 ? '0' + i : i
  }

  const dt = new Date(activity?.time)
  const h = fixTime(dt.getHours())
  const m = fixTime(dt.getMinutes())
  const s = fixTime(dt.getSeconds())

  return (
    <div className='activity-wrapper activity-section' onClick={() => handleActivityClick(data)}>
      <span className='left-side'>
        <span className='time'>
          {h}:{m}:{s}
        </span>
        <span className='description'>{parse(domPurify.sanitize(activity?.text))}</span>
      </span>
      <span className='arrow'>
        <ArrowRightWhiteSmallIcon />
      </span>
    </div>
  )
}

export default ActivityInfoLine
